import { SuccessLarge, WarningLarge, FailureLarge } from '@yme/assets/icons';
import { colorAccentAlert100, colorAccentSuccess200, colorAccentError100, } from '@yme/tokens/colors';
export const ICON_MAP = {
    success: SuccessLarge,
    error: FailureLarge,
    warning: WarningLarge,
};
export const COLOR_MAP = {
    success: colorAccentSuccess200,
    error: colorAccentError100,
    warning: colorAccentAlert100,
};
